import { legacy_createStore as createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";

// import profile from '../reducers/profile';

//You may optionally specify it to hydrate the state from the server in universal apps,
// or to restore a previously serialized user session
// const initialState = {};

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(logger, thunk))
);

// export default configureStore;
// src/app/store.ts
// import { configureStore, Action } from '@reduxjs/toolkit'
// import { useDispatch } from 'react-redux'
// import { ThunkAction } from 'redux-thunk'
// import {logger} from 'redux-logger'

// import rootReducer, { RootState } from './reducers/rootReducer'

// const store = configureStore({
//     reducer: rootReducer,
//     middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
// })

// export type AppDispatch = typeof store.dispatch
// export const useAppDispatch = () => useDispatch()
// export type AppThunk = ThunkAction<void, RootState, unknown, Action>

export default store;
